import { X } from 'lucide-react'
import { formatLocationDropdownLabel } from '../../utils/locationDropdownLabel.js'

const locationLabel = (loc, fallbackId, useLrLabels = false) =>
  formatLocationDropdownLabel(loc, useLrLabels)
  || loc?.location
  || loc?.hub_name
  || loc?.name
  || fallbackId

const MlLocationChips = ({
  locations = [],
  selectedIds = [],
  onRemove,
  label,
  emptyLabel = '',
  compact = false,
  useLrLabels = false,
}) => {
  const items = (selectedIds || []).map((id) => ({
    id,
    loc: locations.find((item) => String(item.id || item.hub_id) === String(id)),
  }))

  if (!items.length) {
    return emptyLabel ? <p className="text-xs sm:text-sm text-gray-400 py-1">{emptyLabel}</p> : null
  }

  return (
    <div className="min-w-0">
      {label ? (
        <p className="text-[10px] sm:text-xs font-medium text-gray-500 mb-1">{label}</p>
      ) : null}
      <div className={`flex flex-wrap w-full min-w-0 content-start ${compact ? 'gap-1' : 'gap-1.5'}`}>
        {items.map(({ id, loc }) => {
          const name = locationLabel(loc, id, useLrLabels)
          return (
            <span
              key={id}
              className={
                compact
                  ? 'inline-flex items-center gap-0.5 max-w-full min-w-0 rounded-md border border-blue-200 bg-blue-50 px-1.5 py-0.5 text-[10px] sm:text-[11px] text-blue-800'
                  : 'inline-flex items-start gap-1 max-w-full min-w-0 rounded-lg border border-blue-200 bg-blue-50 px-2 py-1 text-xs text-blue-800'
              }
            >
              <span className="min-w-0 flex-1 font-medium whitespace-normal break-words [overflow-wrap:anywhere] leading-snug">
                {name}
              </span>
              {onRemove && id != null ? (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation()
                    onRemove(id)
                  }}
                  className={`shrink-0 text-blue-500 hover:text-red-500 ${compact ? '' : 'mt-0.5'}`}
                  aria-label={`Remove ${name}`}
                >
                  <X className={compact ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
                </button>
              ) : null}
            </span>
          )
        })}
      </div>
    </div>
  )
}

export default MlLocationChips
